export default __webpack_public_path__ + "static/media/confirmTb.4f0c0a02.svg";